import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m19.5 3 1 .994v17l-1 1H4.454L3.5 21V4l1-.994 2.25-.001V4.5L8.5 6.25h7l1.75-1.75V3.001L19.5 3zM7.501 16.506a.994.994 0 1 0 0 1.988.994.994 0 0 0 0-1.988zm9.568.119H11v1.75h6.069v-1.75zm-9.568-4.12a.994.994 0 1 0 0 1.99.994.994 0 0 0 0-1.99zm9.568.12H11v1.75h6.069v-1.75zm-9.568-4.12a.994.994 0 1 0 0 1.99.994.994 0 0 0 0-1.99zm9.568.12H11v1.75h6.069v-1.75zM15.5 4.5h-7V2h7v2.5z",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }